<!--
 * @Author: rossdong@yntengyun.com
 * @Date: 2024-10-14 17:28:52
 * @Description:  A 考核项 考评情况
-->
<template>
  <div class="mx-12">
    <div class=" mt-24 mb-12 text-[#333333] text-16  font-bold">
      考评信息
    </div>
    <div class="card-bg">
      <div class="flex-col text-[#999999] text-12">
<!--    扣分原因    -->
        <div class="" v-if="data.deduction || data.audited == 1">扣分原因：{{ data.deductionReason }}</div>
        <div class=""  v-else>扣分情况待审核</div>
<!--    审核时间-->
        <div class="mt-6" v-if="data.auditTime || data.audited == 1">审核时间：{{ data.auditTime }}</div>
      </div>
    </div>

  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  name: 'AAssessInfo',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    // 这里存放数据
    return {
      title: '',

    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {

  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, // 生命周期 - 创建之前
  beforeMount() { }, // 生命周期 - 挂载之前
  beforeUpdate() { }, // 生命周期 - 更新之前
  updated() { }, // 生命周期 - 更新之后
  beforeDestroy() { }, // 生命周期 - 销毁之前
  destroyed() { }, // 生命周期 - 销毁完成
  activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>


<style lang="less" scoped>
.card-bg {
  background-color: #fff;
  padding-top: 16px;
  padding-bottom: 16px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
  border-radius: 3px;
  padding-left: 12px;
  padding-right: 12px;
}
</style>